import { UserDTO } from '@reposit/api-client';
import React from 'react';
import IdentifierValue from '../../IdentifierValue';
import { StyledLink } from '../../Typography';

export type RepositActor = Pick<UserDTO, 'id' | 'firstName' | 'lastName' | 'email'>;

export const formatRepositActorLabel = (user?: RepositActor | null): string | undefined => {
  if (!user) {
    return undefined;
  }

  const name = [user.firstName, user.lastName].filter(Boolean).join(' ');
  return name || user.email || user.id;
};

interface RepositActorLinkProps {
  user?: RepositActor | null;
}

const RepositActorLink: React.FC<RepositActorLinkProps> = ({ user }) => {
  const label = formatRepositActorLabel(user);
  if (!user || !user.id || !label) {
    return <>(Unknown)</>;
  }

  return (
    <StyledLink to={`/users/${user.id}`}>{label === user.id ? <IdentifierValue>{label}</IdentifierValue> : label}</StyledLink>
  );
};

export default RepositActorLink;
